
import Vue from 'vue';
import Component from 'vue-class-component';

// Store types
import { FooterFloatingAction, FooterMutation, FooterNext } from '@/store/store.types';

/**
 *  Base class for every step of the tool.
 */
@Component
export default class BaseStep extends Vue {

    /**
     *
     *  Used to scroll the tool to the top of the page when a step is mounted.
     *
     *  (!) Must be invoked by any step that implements this base step
     *
     */
    protected stepMounted(): void {

        const stepsContainer: HTMLElement | null = document.getElementById('steps');

        if (!stepsContainer) {

            return;

        }

        stepsContainer.scrollTo({ top: 0, behavior: 'smooth' });

    }

    /**
     *
     *  Used to update the settings of the footer's floating action.
     *
     *  (i) Because the footer component is bound to the store's
     *  state, any changes will immediately be reflected by it
     *
     *  @param action The settings of the footer's floating
     *  action or null to hide it
     *
     */
    protected setFooterFloatingAction(action: FooterFloatingAction | null): void {

        this.$store.commit(FooterMutation.FLOATING_ACTION, action);

    }

    /**
     *
     *  Used to update the settings of the footer's next button.
     *
     *  (i) Because the footer component is bound to the store's
     *  state, any changes will immediately be reflected by it
     *
     *  @param next The settings of the footer's next
     *  button or null to hide it
     *
     */
    protected setFooterNext(next: Partial<FooterNext> | null): void {

        this.$store.commit(FooterMutation.NEXT, next);

    }

}

